import React from 'react';

import BookingFinish from 'components/experiment/poc/BookingFinish.component';
import BookingStart from 'components/experiment/poc/BookingStart.component';
import fromAnyToString from 'utils/converters/fromAnyToString';
import logger from 'utils/logger.util';

const L = logger('Poc'); // eslint-disable-line no-unused-vars

// noinspection CssUnresolvedCustomProperty
const CSS = `

:root {
  --gap: 16px;
  --gap-half: 8px;
}

* {
  margin:0; 
  padding:0;
}

:where(section, h1, p){
  margin: var(--gap-half);
  padding: var(--gap); 
}

:where(form) {
  margin: var(--gap); 
}

:where(div, button) {
  padding: var(--gap); 
}

main {
  font-size: 16px;
  font-family: sans-serif;
}

:where(main, article, header) {
  width:  calc(100% - 2 * var(--gap));
  display: flex;
  flex-direction: column;
  place-items: center;
}

:where(main, article) :where(h1, p) {
  display: flex;
  place-items: center;
}

:where(button) {
  cursor: pointer;
}

:where(form, section) {
  display: flex;
  flex-direction: column;
  place-items: baseline;
  width: 100%;
}

form {
  align-items: stretch;
  width: clamp(160px, 100%, 480px);
  
  & * {
    margin-block: var(--gap-half);
    padding-block: var(--gap-half);
  }
    
  & input {
    min-width: 40ch;
    padding:  var(--gap-half);
    border: 1px solid #cccccc;
  } 
  
  & label {
    display: inline-flex ;
    align-items: center;
    justify-content: space-between;
  }
  
  & #start { text-align: center; }
  
  & button { place-self: center; }
}
     
`;

const Poc = () => {
  const location = fromAnyToString(window.location);
  L.info('()', 'location:', location);

  return (
    <main data-bem="Poc">
      <style data-bem="Poc__style" type="text/css">
        {CSS}
      </style>

      <header data-bem="Poc__header">
        <h1>POC Booking</h1>
      </header>

      {location.includes('/poc/booking-start/') && <BookingStart />}
      {location.includes('/poc/booking-finish/') && <BookingFinish />}
    </main>
  );
};

export default Poc;
